import React from 'react';
import PropTypes from 'prop-types';
import {alpha, useTheme} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import {CategoryScale, Chart as ChartJS, Filler, LinearScale, LineElement, PointElement, Tooltip} from 'chart.js';
import {Line} from 'react-chartjs-2';
import {useEstilosAcompanhamento} from './estilosAcompanhamento.js';
import {formatarData, rotuloDia} from './acompanhamentoEstatistico.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Filler);

/* Evolução diária das inscrições do processo (dias já preenchidos, inclusive os sem inscrição). */
export default function GraficoEvolucaoInscricoes({dias}) {
    const classes = useEstilosAcompanhamento();
    const theme = useTheme();

    if (!dias || dias.length === 0) {
        return <Typography className={classes.semDados}>Nenhum dado disponível.</Typography>;
    }

    const data = {
        labels: dias.map(dia => rotuloDia(dia.data)),
        datasets: [{
            label: 'Inscrições',
            data: dias.map(dia => dia.quantidade),
            borderColor: theme.palette.primary.main,
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
            pointBackgroundColor: theme.palette.primary.main,
            fill: true,
            tension: 0.3
        }]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {display: false},
            tooltip: {
                callbacks: {
                    title: itens => (itens.length ? formatarData(dias[itens[0].dataIndex].data) : '')
                }
            }
        },
        scales: {
            y: {beginAtZero: true, ticks: {precision: 0}},
            x: {ticks: {autoSkip: true, maxRotation: 0}}
        }
    };

    return (
        <div className={classes.grafico}>
            <Line data={data} options={options}/>
        </div>
    );
}

GraficoEvolucaoInscricoes.propTypes = {
    dias: PropTypes.arrayOf(PropTypes.shape({
        data: PropTypes.string.isRequired,
        quantidade: PropTypes.number.isRequired
    }))
};
